import api from '@/services/api'

export const updateNBox = async (nboxId, nbox) => {
    try {
        return api.put(`n-boxes/${nboxId}`, nbox)
    } catch (e) {
        console.log(e)
    }
}
